<template>
	<div class="animated fadeIn">
		<h1 class="text-light">{{$t('transaction.title')}}</h1>

		<b-row>
			<b-col xl="12" lg="12" md="12">
	        <b-card v-if="show_usage_list">
	        	<v-server-table
              :columns="logcolumns"
              :data="logdata"
              :options="logoptions"
              :theme="theme"
              ref="logDataTable"
              id="logDataTable"
              class="d-none d-md-block d-lg-block d-xl-block">
	        		<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : $t('unknow')}}</a>
					    <a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>
					    <a slot="inout" slot-scope="props">
						    <span class="text-primary" v-if="props.row.inout==='IN'">{{$t('transaction.top_up')}}</span>
						    <span class="text-warning" v-if="props.row.inout==='OUT'">{{$t('transaction.deduct_points')}}</span>
					    </a>
					    <a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
				    </v-server-table>

            <b-card
                v-if="card_records.length"
                v-for="(entry, idx) in card_records"
                :v-key="`history-entry-{idx}`"
                :header="`${entry.name || $t('transaction.payment_transaction')}`"
                class="d-block d-sm-block d-md-none d-lg-none d-xl-none">
                <div class="col-12">
                  <label class="">{{$t('transaction.transaction_id')}}：</label>
                  <span>{{entry.id}}</span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('transaction.category')}}：</label>
                  <span :class="entry.inout === 'OUT' ? 'text-warning': 'text-primary'">
                    {{entry.inout==='IN'?$t('transaction.top_up'):$t('transaction.deduct_points')}}
                  </span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('time')}}：</label>
                  <span>{{entry.created.substring(0, 16)}}</span>
                </div>
                
                <div class="col-12">
                  <label class="">{{$t('transaction.bonus')}}：</label>
                  <span>{{entry.bonus}}{{$t('s_points')}}</span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('transaction.amount')}}：</label>
                  <span>{{entry.amount}}{{$t('s_points')}}({{$math.round(entry.amount * 115) / 100}}{{$t('price_unit')}})</span>
                </div>
                <div class="col-12">
                  <label class="">{{$t('transaction.device_name')}}：</label>
                  <span>{{entry.name || $t('none')}}</span>
                </div>
				<div class="col-12">
					<label class="">{{$t('transaction.geo_location')}}：</label>
					<span>{{entry.geo_location || $t('none')}}</span>
				</div>
                <div v-if="entry.Coupon && entry.Coupon.sn" class="col-12">
                  <label class="">{{$t('transaction.promo_code')}}：</label>
                  <span>{{entry.Coupon.sn}}</span>
                </div>

            </b-card>

            <b-modal :title="$t('qrcode_scanning')" v-model="showCameraModal" :ok-title="$t('ok')" :ok-only="true" :hide-footer="true" @hidden="hideScanner()">
              <b-alert :show="showCameraModal" variant="success"><i class="fa fa-exclamation-triangle"></i> {{$t('please_qrcode_scanning')}}</b-alert>
              <!-- <canvas id="qrcode-window" v-if="show_qrcode_canvas"></canvas> -->
              <!-- <video id="qrcode-video" playsinline muted></video> -->
              <video
                v-show="showCameraModal"
                id="qrvideo"
                autoplay
                muted
                loop
                playsinline
                webkit-playsinline
                style="border: 1px solid gray; width: 100%; height: 100%"></video>
              <p class="text-primary">{{qrcode_string}}</p>
            </b-modal>

            <div class="d-none d-inline-block d-sm-inline-block d-md-none d-lg-none d-xl-none col-12 overflow-auto">
              <b-pagination
                align="center"
                v-if="card_records.length"
                v-model="card_current_page"
                :total-rows="card_record_count"
                :per-page="card_limit"
                @input="gotoPage">
              </b-pagination>
            </div>
	    	</b-card>
	    </b-col>
		</b-row>

		<b-modal :title="$t('error_message')" v-model="showErrorModal" :ok-title="$t('ok')" :ok-only="true">
	    	<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import {ServerTable, Event} from 'vue-tables-2'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import io from 'socket.io-client'
import moment from 'moment-timezone'

import HistoryLineChart from '@/views/HistoryLineChart'

import { BrowserQRCodeReader } from '@zxing/library';

const codeReader = new BrowserQRCodeReader();

Vue.use(ServerTable)

let eventbus = config.eventbus;
let scanner  = null;

let getUrlParameter = function getUrlParameter(url) {
  let sPageURL = url.substring(url.indexOf('?')+1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i,
      rlt={};

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      rlt[sParameterName[0]] = sParameterName[1];
  }

  return rlt;
};//eo getUrlParameter

export default {
	name: 'TransactionHistory',
	components: {
		vSelect,
		HistoryLineChart,
		ServerTable,
		Event,
	},
	notifications,
	data(){

		let $tz = moment().tz(config.timezone);
		let root = this;

		let selected_year = $tz.format('YYYY');
		let year_options  = [
			selected_year,
			$tz.subtract(1, 'year').format('YYYY')
		];

		$tz = moment().tz(config.timezone);

		let selected_month = $tz.format('MM');
		let month_options  = [];

		// console.info('selected_month:', selected_month);

		for(let i = 1 ; i <= 12 ; i++){
			month_options.push( i <= 9 ? '0' + i : '' + i );			
		}

		return {
			selected_year,
			year_options,
			selected_month,
			month_options,
			theme: '',
			usage_line_chart_data: [],
			logdata: [],
			card_records: [],
			card_record_count: 0,
			card_record_total_page: 1,
			card_current_page: 1,
			card_limit: 25,
			show_usage_line_chart: false,
			show_usage_list: true,
			start_time:'',
			end_time:'',
			showErrorModal: false,
			showCameraModal: false,
			qrcode_string: '',
			errorMsg:'',
			logcolumns: ['id','inout', 'amount', 'bonus', 'name', 'geo_location', 'created'],
			logoptions: {
				headings: {
					id: this.$t('transaction.logoptions.id'),
					geo_location: this.$t('transaction.logoptions.geo_location'),
					inout: this.$t('transaction.logoptions.inout'),
					bonus: this.$t('transaction.logoptions.bonus'),
					amount: this.$t('transaction.logoptions.amount'),
					name: this.$t('transaction.logoptions.name'),
					created: this.$t('transaction.logoptions.created')
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['id', 'inout', 'bonus', 'amount', 'geo_location', 'name'],
				filterable: ['id', 'inout', 'bonus', 'amount', 'geo_location', 'name'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let app = this;
					let action = `${config.mqtt_root}/get_transaction_records`;
					let params = {
						// token: app.$state.$get('adminuser').token,
						user_id: encodeURIComponent(this.$state.$get('user').uuid),
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('user').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						root.card_records = result.data || [];
						root.card_record_count = result.count || 0;
						root.card_current_page = params.page;
						root.card_limit = params.limit;
						if (root.card_record_count) {
							root.card_record_total_page = Math.ceil(root.card_record_count / params.limit);
						}
						// console.info('app.card_records: ', root.card_records);
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
			cameraDevices: [],
		}
	},//eo data
	created() {
		let app = this;

		app.$on('qrcodeDetected', function(result){
			// console.info('qr result:', result);

			app.$emit('reveived-qrcode', result);
			app.show_qrcode_canvas = false; 
			app.showCameraModal    = false;

			let params = getUrlParameter(result);

			if(params && params.uuid){
				app.uuid = decodeURIComponent(params.uuid);
				app.$state.$set('uuid', app.uuid);

				//Attention!! JQuery.param will add encodeURIComponent() for params automatically. So "DO NOT" add by yourself(Avoid double encode issue).
				let href = location.origin + '/#/dashboard/showdevice?' + jQuery.param({
				uuid: app.uuid
				});

				// console.info('href:', href);

				window.location = href;

				location.reload();
			}
		});
	},

	mounted() {
		let app   = this;
		let user  = this.$state.$get('user');
		let token = user ? this.$state.$get('user').token : null;

		if(!token){
			this.$state.$set('error', config.error.INVALID_USER);
			this.$router.push('/');
			return;
		}
		eventbus.$on('start-qrcode-scanning', this.openQrCodeScanner);

		jQuery('.VueTables__search-field input').attr('placeholder', this.$t('search'));
		
	},//eo mounted

	watch: {
		'$i18n.locale'() {
			//console.info('watch $i18n.locale');
			this.$nextTick(() => {
				this.updateTableOptions();
			});
		},
	},

	methods: {
		openQrCodeScanner() {
		let app = this;

		app.showCameraModal       = true
		app.show_scan_qrcode_msg = true;
		app.show_qrcode_canvas   = true;

		// let _ccc = setTimeout(() => {
		//  clearTimeout(_ccc);
		//  init_qrcode_reader(app);
		// }, 1000);

		codeReader
		.listVideoInputDevices()
		.then((videoInputDevices) => {
			let targetCamera;
			videoInputDevices.forEach((device) => {
			this.cameraDevices.push(`${device.label}, ${device.deviceId}`);
			if (this.camera === 'front' && device.label.toLowerCase().indexOf('front') !== -1) {
				targetCamera = device.deviceId;
				return false;
			}
			return true;
			});
			codeReader
			.decodeFromInputVideoDevice(undefined, 'qrvideo')
			.then(result => this.onDecode(result.text))
			.catch(err => {
			// this.showError({message:this.$t('qr_code_detect_error')});
			console.error(err)
			});
		})
		.catch(err => { 
			this.showError({message:this.$t('qr_code_detect_error')});
			console.error(err)
		});

		},//eo openQrCodeScanner
		onDecode(data) {
		this.$emit('qrcodeDetected', data);
		this.showSuccess({message:this.$t('qr_code_detected')});
		},
		hideScanner(){
		// let app = this;
		// app.getVideo().stop();
		if(scanner !== null && scanner.destroy){
			scanner.destroy();
			scanner = null;
		}
		},//eo hideScanner
		gotoPage(page) {
		// console.info('new page: ', page);
		this.$refs.logDataTable.setPage(page);
		},
		updateTableOptions() {
			this.logoptions.headings.id = this.$t('transaction.logoptions.id');
			this.logoptions.headings.geo_location = this.$t('transaction.logoptions.geo_location');
			this.logoptions.headings.inout = this.$t('transaction.logoptions.inout');
			this.logoptions.headings.bonus = this.$t('transaction.logoptions.bonus');
			this.logoptions.headings.amount = this.$t('transaction.logoptions.amount');
			this.logoptions.headings.name = this.$t('transaction.logoptions.name');
			this.logoptions.headings.created = this.$t('transaction.logoptions.created');
			this.$forceUpdate();
		},
	},//eo methods
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />